import { useAuthStore } from '@/core/stores'

interface TokenStorage {
  getToken(): string | null
  setToken(token: string): void
  getRefreshToken(): string | null
  setRefreshToken(token: string): void
  clearTokens(): void
}

class ZustandTokenStorage implements TokenStorage {
  getToken(): string | null {
    return useAuthStore.getState().accessToken
  }

  setToken(token: string): void {
    useAuthStore.getState().setToken(token)
  }

  getRefreshToken(): string | null {
    return useAuthStore.getState().refreshToken
  }

  setRefreshToken(token: string): void {
    useAuthStore.getState().setRefreshToken(token)
  }

  clearTokens(): void {
    useAuthStore.getState().clearTokens()
  }
}

export class AuthTokenService {
  private static instance: AuthTokenService
  private storage: TokenStorage

  private constructor() {
    this.storage = new ZustandTokenStorage()
  }

  static getInstance(): AuthTokenService {
    if (!AuthTokenService.instance) {
      AuthTokenService.instance = new AuthTokenService()
    }
    return AuthTokenService.instance
  }

  getToken(): string | null {
    return useAuthStore.getState().getToken()
  }

  setWebViewToken(token: string): void {
    useAuthStore.getState().setWebViewToken(token)
  }

  clearWebViewToken(): void {
    useAuthStore.getState().clearWebViewToken()
  }

  hasWebViewToken(): boolean {
    return useAuthStore.getState().hasWebViewToken()
  }

  setToken(token: string): void {
    this.storage.setToken(token)
  }

  getRefreshToken(): string | null {
    return this.storage.getRefreshToken()
  }

  setRefreshToken(token: string): void {
    this.storage.setRefreshToken(token)
  }

  clearTokens(): void {
    this.storage.clearTokens()
  }

  isTokenExpired(token: string): boolean {
    return useAuthStore.getState().isTokenExpired(token)
  }

  isAuthenticated(): boolean {
    return useAuthStore.getState().isAuthenticated()
  }

  getUserFromToken(token: string): { uid: string; email?: string; name?: string } | null {
    return useAuthStore.getState().getUserFromToken(token)
  }
}